import { Injectable } from '@angular/core';
import {getCookie} from "../helpers/utils";
import {HttpClient} from "@angular/common/http";

@Injectable({
  providedIn: 'root'
})
export class SingleRatingPageService {

  private _apPrefix = '/api/v1/';
  private _ratingId: number = -1;
  private _amountOfRightPartHeaders = 3;
  private _ratingDataUrl = `${this._apPrefix}ratings/ /rating_detail/`;
  private _leftPartHeaders = ['#', 'Участник'];
  private _mutablePartHeaders: string[] = [];
  private _rightPartHeaders: string[] = [];
  private _ratingTitle = '';
  private _listOfPlayers: string[] = [];
  private _statsList: Array<number|null>[] = [];
  private _rightPartDataList: RightPartDataItem[] = [];
  private _rawPlayersDataList: PlayerRatingData[] = [];
  private _isStaff: boolean = false;
  constructor(
    private http: HttpClient
  ) { }
  private getCsrfToken(): string {
    return getCookie('csrftoken');
  }


  get ratingId(): number {
    return this._ratingId;
  }

  set ratingId(value: number) {
    this._ratingId = value;
  }

  getCertainRatingDetail() {
    return this.http.get(
      this._ratingDataUrl
        .replace(' ', this._ratingId + '')
    );
  }

  parseHeaders(response: RatingDetails) {
    const listOfHeaders = response.header;
    this.rightPartHeaders = listOfHeaders.slice(-this._amountOfRightPartHeaders);
    this.ratingTitle = listOfHeaders[0];
    this.mutablePartHeaders = listOfHeaders.slice(1, -this._amountOfRightPartHeaders);
  }

  parseBody(response: RatingDetails) {
    const listOfPlayers = response.body;
    this.rawPlayersDataList = listOfPlayers;
    listOfPlayers.forEach((playerStats) => {
      const statsLength = playerStats.statistic.length;
      this.listOfPlayers.push(playerStats.player_full_name);

      this.statsList.push(playerStats.statistic.slice(0, statsLength - 3));
      this.rightPartDataList.push({
        sum: playerStats.statistic[statsLength - 1],
        roundsAmount: playerStats.statistic[statsLength - 2],
        factor: playerStats.statistic[statsLength - 3],
      });

    });
  }

  parseResponse(response: RatingDetails) {
    this.parseHeaders(response);
    this.parseBody(response);
  }


  get leftPartHeaders() {
    return this._leftPartHeaders;
  };

  set leftPartHeaders(value) {
    this._leftPartHeaders = [...value];
  }

  get mutablePartHeaders() {
    return this._mutablePartHeaders;
  };

  set mutablePartHeaders(value) {
    this._mutablePartHeaders = [...value];
  }

  get rightPartHeaders() {
    return this._rightPartHeaders;
  };

  set rightPartHeaders(value) {
    this._rightPartHeaders = [...value];
  }

  get ratingTitle() {
    return this._ratingTitle;
  }

  set ratingTitle(value) {
    this._ratingTitle = value;
  }

  get listOfPlayers() {
    return this._listOfPlayers
  };
  set listOfPlayers(value) {
    this._listOfPlayers = [...value];
  };
  get statsList() {
    return this._statsList;
  };

  set statsList(value) {
    this._statsList = [...value];
  };

  get rightPartDataList() {
    return this._rightPartDataList;
  };

  set rightPartDataList(value) {
    this._rightPartDataList = value;
  };

  get rawPlayersDataList() {
    return this._rawPlayersDataList;
  }

  set rawPlayersDataList(list) {
    this._rawPlayersDataList = list;
  }

  get isStaff(): boolean {
    return this._isStaff;
  }

  set isStaff(value) {
    this._isStaff = value;
  }

}
export interface PlayerRatingData {
  player_id: number,
  player_full_name: string,
  statistic: Array<number|null>
}
export interface RatingDetails {
  header: string[],
  body: PlayerRatingData[],
}

export interface RightPartDataItem {
  sum: number | null,
  roundsAmount: number,
  factor: number,
}
